import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF listo para usar.'
  }, {
    q: '¿Sirve para escuelas rurales y agrotécnicas?',
    a: 'Sí, está pensado específicamente para contextos rurales y se adapta a escuelas agrotécnicas y secundarias.'
  }, {
    q: '¿El material es editable?',
    a: 'Viene en PDF de alta calidad, listo para imprimir o compartir digitalmente.'
  }, {
    q: '¿Los 4 bonos están incluidos?',
    a: 'Sí, ambos planes incluyen los 4 bonos de regalo.'
  }, {
    q: '¿Puedo comprar el básico y actualizar después?',
    a: 'Sí, pero recomendamos el Sistema Pro desde el inicio por el valor agregado.'
  }, {
    q: '¿Funciona para clases presenciales y virtuales?',
    a: 'Totalmente, se adapta a ambos formatos.'
  }, {
    q: '¿Incluye contenido actualizado sobre problemáticas rurales?',
    a: 'Sí, todo basado en la realidad productiva y ambiental actual de Argentina.'
  }, {
    q: '¿Está organizado por nivel de dificultad?',
    a: 'Sí, progresión lógica desde conceptos básicos hasta análisis complejos.'
  }, {
    q: '¿Tiene garantía?',
    a: '7 días de garantía total. Si no te sirve, devolución del 100%.'
  }, {
    q: '¿Qué diferencia tiene con material de internet?',
    a: 'No son textos sueltos. Es un sistema pedagógico completo pensado para enseñar geografía rural.'
  }];
  return <section className="bg-[#0E1F19] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-38">
          PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-1.5" data-id="element-39">
          {faqs.map((faq, i) => <div key={i} className="bg-[#071A14] border border-[#1F3D2B] rounded-lg overflow-hidden" data-id="element-40">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-3 text-left hover:bg-[#102A1F] transition-colors" data-id="element-41">
                <span className="font-black text-white text-xs md:text-sm pr-3 leading-tight" data-id="element-42">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} data-id="element-43">
                  <ChevronDown className="w-4 h-4 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-44" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-45">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-46">
                    <div className="px-3 pb-3 text-[#BFC9C5] font-bold text-[10px] md:text-xs border-t border-[#1F3D2B] pt-2 bg-[#071A14] leading-snug" data-id="element-47">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}